<template>
  <div>
    <vue-slider
      v-model="values"
      :tooltip="'none'"
      :dotSize="16"
      :height="6"
      :min="Number(filter.minimum)"
      :max="Number(filter.maximum)"
      @drag-end="dragEnd(filter)"
      @click.native="dragEnd(filter)"
      direction="rtl"
    />

    <div class="range-slider-values">
      <div>
       {{ values[0] | commaSeperator }}
      </div>

      <div>
       {{ values[1] | commaSeperator }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

export default {
  name: "FilterItemRange",

  props: ["filter"],

  components: {
    VueSlider,
  },
  data() {
    return {
      values: [
        Number(this.filter.minimumValue).toFixed(0),
        Number(this.filter.maximumValue).toFixed(0),
      ],
    };
  },

  methods: {
    ...mapActions(["onChangeFilter"]),

    dragEnd(filterItem) {
      let filterItemChange = {
        slug: filterItem.slug,
        minimum: this.values[0],
        maximum: this.values[1],
        showType: filterItem.showType,
        isSelected: filterItem.isSelected,
        type: filterItem.type,
      };
      this.onChangeFilter(filterItemChange);
    },
  },

  filters: {
    commaSeperator(value) {
      if (!value) {
        return 0;
      }
      value = Number(value).toFixed(0);
      value = Intl.NumberFormat().format(value);
      return value;
    },
  },
};
</script>
